module.exports = __webpack_public_path__ + "static/media/aogmt1.2cedbf21.png";